import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { UserModule } from '../store/modules/user'
import { checkNoticeCanJump } from '@/apis/home'
import { Toast } from 'vant'
import { AppModule } from '../store/modules/app'
import * as dd from 'dingtalk-jsapi';
const whiteList = ['/outForm']
Vue.use(VueRouter)
/* 
meta.hiddenBackBtn 隐藏后退按钮
meta.backRoute 后退到某个页面
meta.backLength 后退几级
*/
const routes = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/login.vue'),
    meta: { hiddenBackBtn: true }
  },
  {
    path: '/outForm',
    component: () => import(/* webpackChunkName: "outForm" */ '@/views/outForm/outForm.vue'),
    meta: { hiddenBackBtn: true }
  },
  {
    path: '/outFormResult',
    component: () => import(/* webpackChunkName: "outForm" */ '@/views/outForm/outFormResult.vue'),
    meta: { hiddenBackBtn: true }
  },
  {
    path: '/register',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/register.vue'),
    meta: { hiddenBackBtn: true }
  },
  {
    path: '/resetPwd',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/resetPwd.vue'),
    meta: { hiddenBackBtn: true }
  },
  {
    path: '/home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/home.vue'),
    meta: { hiddenBackBtn: true }
  },
  {
    path: '/message',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/message.vue'),
    meta: { hidden: false, backRoute: '/home' },
    children: [
      {
        path: ':messageId',
        component: () => import(/* webpackChunkName: "home" */ '@/views/home/messageDetail.vue'),
      },
    ]
  },
  {
    path: '/userMsg',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/userMsg.vue'),
    meta: { backRoute: '/home' }
  },
  {
    path: '/matter',
    redirect: '/matter/upcoming',
    meta: { hidden: false }
  },
  {
    path: '/matter/:tabName',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/myMatter.vue'),

    meta: { hidden: false, backRoute: '/home' }
  },
  {
    path: '/matter/:tabName/:processId/:nodeId',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/approvalBox.vue'),
    meta: { hidden: false, backLength: 2 }
  },
  {
    path: '/sheet/:processId/track',
    component: () => import(/* webpackChunkName: "record" */ '@/views/sheet/track.vue'),
    meta: { hidden: false, backLength: -1 }
  },
  {
    path: '/protocol',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/protocol.vue'),
    meta: { hiddenBackBtn: true }
  },
  {
    path: '/:applicationId',
    component: () => import(/* webpackChunkName: "sheet" */ '@/views/sheet/index.vue'),
    meta: { backRoute: '/home' }
  },
  {
    path: '/:applicationId/:worksheetId/sheet',
    component: () => import(/* webpackChunkName: "sheet" */ '@/views/sheet/summary.vue'),
  },
  // {
  //   path: '/sheet/:applicationId/:worksheetId/chart',
  //   component: () => import(/* webpackChunkName: "sheet" */ '@/views/sheet/chart/index.vue'),
  // },
  {
    path: '/:applicationId/:worksheetId/chart/:viewId',
    component: () => import(/* webpackChunkName: "sheet" */ '@/views/sheet/chart/index.vue'),
    meta: { hidden: false, backLength: 3 }
  },
  {
    path: '/:applicationId/:worksheetId/sheet/:viewId',
    component: () => import(/* webpackChunkName: "sheet" */ '@/views/sheet/summary.vue'),
    meta: { hidden: false, backLength: 3 }
  },
  {
    path: '/:applicationId/:worksheetId/sheet/:viewId/:recordId',
    component: () => import(/* webpackChunkName: "record" */ '@/views/sheet/record.vue'),
    meta: { backLength: -1 }
  },
  {
    path: '/sheet/:applicationId/:worksheetId/:viewId/:recordId/log',
    component: () => import(/* webpackChunkName: "record" */ '@/views/sheet/log.vue'),
    meta: { hidden: false }
  },
  {
    path: '/sheet/:applicationId/:worksheetId/:viewId/:recordId/discussion',
    component: () => import(/* webpackChunkName: "record" */ '@/views/sheet/discussion.vue'),
    meta: { hidden: false }
  },
  {
    path: '/association/:applicationId/:worksheetId/:viewId/:recordId',
    component: () => import(/* webpackChunkName: "record" */ '@/views/sheet/associationRecord.vue'),
    meta: { backLength: -1 }
  },
  {
    path: '*',
    redirect: (to: any) => {
      const userId = window.localStorage.getItem('userId') || ''
      const companyId = window.localStorage.getItem('companyId') || ''
      if (!(userId && companyId)) {
        if (to.query.externalType) {
          return '/home'
        } else if (to.query.token) {
          window.sessionStorage.setItem('token', to.query.token as string)
          return '/home'
        }
        return '/login'
      } else {
        return '/home'
      }
    },
    meta: { hiddenBackBtn: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    // 白名单可直接访问
    next()
  } else {
    // 刷新
    if (from.path === '/' && to.path !== '/login') {
      if (window.sessionStorage.getItem('externalType') || to.query.externalType) {
        var External = (externalType, code, state) => {
          UserModule.loginByExternal({ externalType, code, state }).then((res) => {
            if (res.success) {
              if (to.query.jump) {
                // 跳转到记录
                let recordId = to.query.jump
                let { applicationId, worksheetId, viewId } = to.params;
                checkNoticeCanJump({ applicationId, worksheetId, viewId, recordId }).then((res1) => {
                  if (res1.success) {
                    if (res1.data.canJump) {
                      next(`/${applicationId}/${worksheetId}/sheet/${viewId}/${recordId}`);
                    } else {
                      Toast.fail(res1.data.message)
                      next('/home');
                    }
                  }
                })
                return
              } else {
                next()
              }
            } else {
              window.localStorage.removeItem('companyId')
              window.localStorage.removeItem('userId')
              next('/login')
            }
          })
        }
        if (to.query.externalType === 'ding_ding') {
          dd.ready(() => {
            const code = dd.runtime.permission.requestAuthCode({
              corpId: `${to.query.state}`,
            });
            code.then(res => {
              const { externalType, state } = to.query
              External(externalType, res.code, state)
            })
          });

        } else {
          const { externalType, code, state } = to.query
          External(externalType, code, state)
        }

      } else if (window.sessionStorage.getItem('token') || to.query.token) {
        const token = to.query.token as string || window.sessionStorage.getItem('token')
        UserModule.loginByToken(token).then((res) => {
          if (res.success) {
            if (to.query.jump) {
              // 跳转到记录
              let recordId = to.query.jump
              let { applicationId, worksheetId, viewId } = to.params;
              checkNoticeCanJump({ applicationId, worksheetId, viewId, recordId }).then((res1) => {
                if (res1.success) {
                  if (res1.data.canJump) {
                    next(`/${applicationId}/${worksheetId}/sheet/${viewId}/${recordId}`);
                  } else {
                    Toast.fail(res1.data.message)
                    next('/home');
                  }
                }
              })
              return
            } else {
              if (to.query.flag === 'cep') {
                AppModule.SET_ENV(to.query.flag)
              }
              next()
            }
          } else {
            window.localStorage.removeItem('companyId')
            window.localStorage.removeItem('userId')
            next('/login')
          }
        })
      } else {
        const form = window.localStorage.getItem('loginForm')
        const userId = window.localStorage.getItem('userId') || ''
        const companyId = window.localStorage.getItem('companyId') || ''
        if (!(userId && companyId)) {
          next('/login')
          return
        }
        if (form) {
          UserModule.login(JSON.parse(form)).then((res) => {
            if (res.success) {
              if (to.query.jump) {
                // 跳转到记录
                let recordId = to.query.jump
                let { applicationId, worksheetId, viewId } = to.params;
                checkNoticeCanJump({ applicationId, worksheetId, viewId, recordId }).then((res1) => {
                  if (res1.success) {
                    if (res1.data.canJump) {
                      next(`/${applicationId}/${worksheetId}/sheet/${viewId}/${recordId}`);
                    } else {
                      Toast.fail(res1.data.message)
                      next('/home');
                    }
                  }
                })
                return
              } else {
                next()
              }
            } else {
              window.localStorage.removeItem('companyId')
              window.localStorage.removeItem('userId')
              next('/login')
            }
          })
        } else {
          window.localStorage.removeItem('companyId')
          window.localStorage.removeItem('userId')
          next('/login')
        }
      }
    } else {
      if (to.path === '/login') {
        const userId = window.localStorage.getItem('userId') || ''
        const companyId = window.localStorage.getItem('companyId') || ''
        if (!(userId && companyId)) {
          next()
        } else {
          next('/home')
        }
      } else {
        next()
      }
    }
  }
})
export default router
